const DateConstructor = Date;

/**
 * Restores the standard behaviour of Date if it has been overridden.
 *
 * Does nothing if the Date object hasn't been overwritten.
 */
export const restoreGlobalDate = (): void => {
  global.Date = DateConstructor;
};

/**
 * Forces Date to return the given date & time as the current date & time.
 *
 * This mutates the global Date object, don't forget to use
 * restoreCurrentGlobalDate() when you're done!
 *
 * @param isoDateTime - ISO8601 formatted date and time string to use.
 */
export const overrideGlobalDate = (isoDateTime: string): void => {
  const stubDate = new DateConstructor(isoDateTime);

  setTimeout(() => {
    stubDate.setMinutes(stubDate.getMinutes() + 1);
  }, 100);

  global.Date = class extends Date {
    constructor(newDate: Date) {
      super();

      /**
       * In order to run tests with date read write
       * we need to be able to set a new date using
       * the global Date method.
       *
       * This is needed because mocking the Date method
       * means whenever our code needs to change the date
       * it always gets forced to whatever date we passed
       * into overrideGlobalDate.
       *
       * To prevent other tests failing, this statement
       * only allows changing of the overridden date
       * value when the year is 2124.
       */
      if (new DateConstructor(newDate).getUTCFullYear() === 2124) {
        return new DateConstructor(newDate);
      }

      // create a new copy of the stubDate to avoid two-way binding issues
      return new DateConstructor(stubDate);
    }
  } as DateConstructor;
};
